<template>
  <div
    id="clear"
    :class="[
      show ? 'show' : '',
    ]"
  >
    <div
      :class="[
        show ? 'show' : '',
        'card',
      ]"
    >
      <div class="card-header">
        <label
          v-if="!showNextContent"
          class="header"
        >Clear Alerts</label>
        <label
          v-else
          class="header"
        >False Positive</label>
      </div>

      <div class="card-content">
        <div
          v-if="!showNextContent"
          class="table-container"
        >
          <v-data-table
            :headers="headers"
            :items="allAlerts"
            show-select
            fixed-header
            hide-default-footer
            disable-pagination
            item-key="index"
            height="300px"
            @item-selected="selectAlerts"
            @toggle-select-all="selectAllAlerts"
          >
            <template #item.firstOccurred="{ item }">
              <td>
                <span>{{ formattedDate(item.firstOccurred) }}</span>
              </td>
            </template>
          </v-data-table>
        </div>
        <div
          v-else
          class="next-content"
        >
          <v-icon
            color="#FF5B52"
            dark
            xx-large
          >
            mdi-alert-circle-outline
          </v-icon>
          <div class="warning-text">
            Are you sure you want to clear {{ selectedAlerts.length }} alert(s)?
          </div>
        </div>
        <div
          v-if="!showNextContent && status === 'Dismissed_Chronic'"
          class="date-picker-header"
        >
          Unmute Date
          <div class="date-picker">
            <DatePicker
              :value="unmuteDate"
              @input="actionUnmuteDateChange($event)"
            />
          </div>
        </div>
        <div
          v-if="!showNextContent && status === 'Dismissed_Chronic'"
          class="action-note"
        >
          <div class="action-note-header">
            Notes for stopping alerts <span class="action-note-sub">(Optional)</span>
          </div>
          <textarea
            class="action-note-textarea"
            placeholder="e.g. Known chronic issue..."
            :value="actionNote"
            @change="actionNoteChange($event.target.value)"
          />
        </div>
      </div>

      <div class="card-footer">
        <div class="btn-container">
          <button
            class="cancel-btn"
            @click="hide(false); reset()"
          >
            Cancel
          </button>
          <button
            v-if="!showNextContent"
            :class="[
              'next-btn',
              !selectedAlerts.length ? 'disable' : '',
            ]"
            :disabled="!selectedAlerts.length"
            @click="showNextContent = true"
          >
            Next
          </button>
          <button
            v-if="showNextContent"
            class="save-btn"
            @click="clearAlerts(selectedAlerts, false); reset()"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import DatePicker from '@shared/components/DatePicker.vue';

export default {
  name: 'ClearAlerts',
  components: {
    DatePicker,
  },
  props: {
    show: Boolean,
    hide: Function,
    allAlerts: Array,
    clearAlerts: Function,
    status: String,
    actionNote: String,
    unmuteDate: [String, Date],
    actionNoteChange: Function,
    actionUnmuteDateChange: Function,
  },
  data() {
    return {
      headers: [{
        text: 'Urgency',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'severity',
      }, {
        text: 'Category',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'category',
      }, {
        text: 'Alert Type',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'type',
      }, {
        text: 'First Occurred On',
        align: 'start',
        filterable: false,
        sortable: false,
        value: 'firstOccurred',
      }],
      selectedAlerts: [],
      showNextContent: false,
    };
  },
  methods: {
    formattedDate(date) {
      if (date) {
        return moment(date).format('M-DD-YY | h:mmA');
      }
      return '--';
    },
    selectAlerts({ item, value }) {
      const alert = _.cloneDeep(item);
      if (value) {
        this.selectedAlerts.push(alert);
      } else {
        this.selectedAlerts = this.selectedAlerts.filter((a) => a.index !== alert.index);
      }
    },
    selectAllAlerts({ items, value }) {
      if (value) {
        this.selectedAlerts = [...items];
      } else {
        this.selectedAlerts = [];
      }
    },
    reset() {
      this.selectedAlerts = [];
      this.showNextContent = true;
      this.actionNoteChange('');

      // Use this until you find a method to unselect all
      setTimeout(() => {
        this.showNextContent = false;
      }, 0);
    },
  },
};
</script>

<style lang="scss">

#clear {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  align-items: center;
  justify-content: center;
  z-index: 5;
  transform: scale(0);
  &.show {
    display: flex;
    transform: scale(1);
  }
  .card {
    position: relative;
    width: 50vw;
    min-width: 500px;
    background-color: $WHITE;
    border-radius: 10px;
    transform: scale(0);
    transition: all .3s;
    &.show {
      transform: scale(1);
    }
    .card-header {
      padding: 10px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      width: 100%;
      background-color: $CONTENTGRAY;
      font-size: 17px;
      font-weight: 600;
      color: $WHITE;
      text-transform: uppercase;
    }
    .card-content {
      padding: 20px;
      .date-picker-header{
        width: 100%;
        font-size: 1.25rem;
        font-weight: 500;
        margin-bottom: 11px;
        .date-picker{
          font-size: 15px;
        }
      }
      .action-note{
        width: 100%;
        font-size: 15px;
        .action-note-header{
          font-size: 1.25rem;
          font-weight: 500;
          margin-bottom: 11px;
          .action-note-sub{
            font-size: 0.75rem;
            color: $N50;
          }
        }
        .action-note-textarea{
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
        }
      }
      .table-container {
        .v-data-table__wrapper {
          thead {
            tr {
              th {
                background-color: $N1;
                color: $N65;
                font-size: 15px;
                font-weight: 600;
                text-transform: uppercase;
                .mdi-checkbox-blank-outline::before,
                .mdi-checkbox-marked::before,
                .mdi-minus-box::before,
                .mdi-arrow-up::before {
                  color: $N65;
                }
              }
            }
          }
          tbody {
            tr {
              td {
                border: 0;
              }
              &:hover {
                background: none;
              }
              &:nth-child(even) {
                background-color: $WHITE;
              }
            }
          }
        }
      }
      .next-content {
        display: grid;
        grid-auto-flow: column;
        justify-content: left;
        align-items: center;
        gap: 10px;
        font-size: 17px;
      }
    }
    .card-footer {
      display: grid;
      justify-content: flex-end;
      border-top: 1px solid $N10;
      padding: 10px;
      .btn-container {
        display: grid;
        grid-auto-flow: column;
        gap: 10px;
        .cancel-btn {
          padding: 5px 10px;
          font-size: 15px;
          border: 1px solid;
          border-radius: 4px;
          font-weight: 500;
        }
        .next-btn, .save-btn {
          padding: 5px 20px;
          font-size: 15px;
          border: 1px solid;
          border-radius: 4px;
          font-weight: 500;
          background-color: $N100;
          color: $WHITE;
        }
        .disable {
          background-color: $N20;
        }
      }
    }
  }
}
</style>
